import { useEffect } from 'react'
import styles from './paymentForm.module.css'
import { FormGroup, Input, Label } from 'reactstrap'

import Paytm from '../../assets/paytm.png'

function MobilePaymentForm({
    paymentMethod,
    handlePaymentMethod,
    paymentGateways = [],
    logoBgColor = '#fff',
}) {

    // convert object response to array
    const gateways = Array.isArray(paymentGateways)
        ? paymentGateways
        : Object.entries(paymentGateways).map(([key, value]) => ({
              payment_gateway: key,
              ...value,
          }))

    // AUTO SELECT
    useEffect(() => {

        if (!paymentMethod && gateways.length > 0) {

            // first try primary account
            let selectedGateway = gateways.find(
                item => item.is_primary_account === true
            )

            // if no primary account then paytm
            if (!selectedGateway) {

                selectedGateway = gateways.find(
                    item =>
                        item.payment_gateway?.toLowerCase() === 'paytm'
                )
            }

            // fallback first item
            if (!selectedGateway) {
                selectedGateway = gateways[0]
            }

            let gatewayValue =
                selectedGateway.payment_gateway?.toLowerCase()

            // convert hdfc -> ccavenue
            if (gatewayValue === 'hdfc') {
                gatewayValue = 'ccavenue'
            }

            // IMPORTANT
            handlePaymentMethod({
                target: {
                    name: 'payment_gateway',
                    value: gatewayValue,
                },
            })
        }

    }, [gateways])

    const getLogo = (gateway) => {

        switch (gateway?.toLowerCase()) {

            case 'paytm':
                return Paytm

            default:
                return null
        }
    }

    return (
        <>
            {gateways.map((item, index) => {

                const gatewayName =
                    item?.payment_gateway?.toLowerCase()

                // send ccavenue for hdfc
                const selectedValue =
                    gatewayName === 'hdfc'
                        ? 'ccavenue'
                        : gatewayName

                const logo = getLogo(gatewayName)

                return (
                    <FormGroup
                        key={index}
                        className={`mx-2 ${styles.fitContent}`}
                        // className={`${styles.fitContent} mb-0`}
                        check
                    >
                        <Label
                            check
                            className="d-flex align-items-center"
                        >
                            <Input
                                type="radio"
                                name="payment_gateway"
                                value={selectedValue}
                                checked={paymentMethod === selectedValue}
                                onChange={handlePaymentMethod}
                                className="my-auto"
                            />

                            {logo ? (
                                <img
                                    src={logo}
                                    alt={gatewayName}
                                    className={styles.paymentMethodLogo}
                                    style={{
                                        backgroundColor: logoBgColor,
                                    }}
                                />
                            ) : (
                                <span
                                    className={`${styles.paymentMethodLogo} fw-500 px-3`}
                                    style={{
                                        backgroundColor: logoBgColor,
                                        padding: '1.8px 14px',
                                        fontSize: '16px',
                                        borderRadius: '4px',
                                        width:'85px'
                                    }}
                                >
                                    {gatewayName === 'hdfc'
                                        ? 'HDFC'
                                        : item?.label || item?.payment_gateway}
                                </span>
                            )}
                        </Label>
                    </FormGroup>
                )
            })}
        </>
    )
}

export default MobilePaymentForm